import { render } from "./UploadField.vue?vue&type=template&id=7bf767ce&scoped=true"
import script from "./UploadField.vue?vue&type=script&lang=js"
export * from "./UploadField.vue?vue&type=script&lang=js"

import "./UploadField.vue?vue&type=style&index=0&id=7bf767ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bf767ce"]])

export default __exports__